<div class="glass-panel overflow-hidden border border-gray-200 dark:border-white/10">
    <div class="overflow-x-auto">
        <table mat-table [dataSource]="data()" matSort (matSortChange)="onMatSortChange($event)" class="mat-mdc-table w-full text-left border-collapse bg-transparent">
            @for (col of columns(); track col.key) {
                <ng-container [matColumnDef]="col.key">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 py-4 text-xs font-semibold uppercase tracking-wider table-header-text"
                        [disabled]="!sortableColumns().includes(col.key)">
                        {{ col.label | transloco }}
                    </th>
                    <td mat-cell *matCellDef="let row" class="px-6 py-4 text-sm font-medium">
                        <ng-container
                            *ngTemplateOutlet="cellTemplate || defaultCell; context: { $implicit: row, column: col }"></ng-container>
                    </td>
                </ng-container>
            }

            <tr mat-header-row *matHeaderRowDef="displayedColumns()" class="table-header-row"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns()" class="table-row-item transition-colors cursor-pointer group"></tr>

            <!-- Empty Row Template -->
            <tr *matNoDataRow>
                <td [attr.colspan]="columns().length" class="px-6 py-8 text-center text-gray-500">
                    No data available.
                </td>
            </tr>
        </table>
    </div>
</div>

<ng-template #defaultCell let-row let-column="column">
    {{ row[column.key] }}
</ng-template>
